import { createContext, defaultValue, useContext } from 'react';

const SharedFileManagerContext = createContext(defaultValue);

export const SharedFileManagerProvider = SharedFileManagerContext.Provider;
export const useSharedFileManager = () => useContext(SharedFileManagerContext);
